import { render, staticRenderFns } from "./ForumNewAnswer.vue?vue&type=template&id=77f2af63&scoped=true"
import script from "./ForumNewAnswer.vue?vue&type=script&lang=ts"
export * from "./ForumNewAnswer.vue?vue&type=script&lang=ts"
import style0 from "./ForumNewAnswer.vue?vue&type=style&index=0&id=77f2af63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f2af63",
  null
  
)

export default component.exports